export const isWebView = () => typeof window !== 'undefined' && window.Native !== undefined
